import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, FONT_SIZE_BTN_CONFIRM_TITLE, BACKGROUND_BTN_CONFIRM, BACKGROUND_BTN_CONFIRM_HOVER, COLOR_BTN_CONFIRM_HOVER, COLOR_CONTROLLED_INPUT_NORMAL} from '../../../globals';


export const StyledBtnConfirm = styled.button`
  padding: 0px ${PADDING_CONTENT_PAGE}px ${PADDING_CONTENT_PAGE}px ${PADDING_CONTENT_PAGE}px;
  font-size: ${FONT_SIZE_BTN_CONFIRM_TITLE}em;
  font-weight: bold;
  color: white;
  border: none;
  background: none;
  background-color: ${BACKGROUND_BTN_CONFIRM}; 
  border-radius: 2px;
  text-align: center;
  vertical-align: middle;
  line-height: 34px; 
  cursor: pointer;
  width: 100%;
  padding: 5px;

  ${(p) => p.disabled ? 
    `background-color: ${COLOR_CONTROLLED_INPUT_NORMAL};
    cursor: auto;`
  : 
    `:hover {
        background-color: ${BACKGROUND_BTN_CONFIRM_HOVER};
        color: ${COLOR_BTN_CONFIRM_HOVER};
    }`
  }

`;



// WEBPACK FOOTER //
// ./src/common/BtnConfirm/styles/StyledBtnConfirm.js